module.exports = __webpack_public_path__ + "img/symbol_0.bf6e097e.png";